import * as UIToolkit from '../../UIToolkit/index';
import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import Select from '../select/index';
import Utils from '../../utils/util';
import { __getLinks__, __replaceAll__ } from './db';
import { setGroupedKey, getGroupList } from './link';
import { updateLayerGroupStausAsync } from './groupStatus';
import { updateLayers, updateLayersWithLayout } from './groupLayout';

function groupDisperse(direction: string = 'both'): void {
    let allSelected: Array<CubeId> = Select.getAll();

    if (!CubeTree.isPartitionList(allSelected)) {
        UIToolkit.tips('该操作仅支持层板');
        return;
    }

    let links: LinkedListInstance[] = __getLinks__();
    let linkTemp: LinkedListInstance[][] = links.map((link: LinkedListInstance): LinkedListInstance[] => {
        let temp: LinkedListInstance[] = Toolkit.linkSplit(link, allSelected, direction);

        return temp;
    });
    
    delGroup(allSelected);
    __replaceAll__(Utils.expandArray(linkTemp));
    updateLayersWithLayout(allSelected);
    updateLayerGroupStausAsync();
}

function delGroup(layers: CubeId[]): void {
    setGroupedKey(layers, 0);
    layers.forEach((layer: CubeId): void => {
        let layerNode: CubeNode = CubeTree.findByCubeId(layer);
        let $left: JQuery<HTMLElement> = layerNode.jView.find('.group-left');
        let $right: JQuery<HTMLElement> = layerNode.jView.find('.group-right');

        $right.removeClass('group-right--show');
        $left.removeClass('group-left--show');
    });
}

export {
    groupDisperse
};
